import React from "react";
import { materialsData } from "../data/mock";
import { Card, CardContent } from "./ui/card";
import {
  Wrench,
  Zap,
  Container,
  Monitor,
  Recycle,
  FileText,
  Cog,
  Briefcase,
} from "lucide-react";

const iconMap = {
  Wrench,
  Zap,
  Container,
  Monitor,
  Recycle,
  FileText,
  Cog,
  Briefcase,
};

export const MaterialsSection = () => {
  return (
    <section id="materials" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 rounded-full bg-teal-500" />
            <span className="text-teal-700 text-sm font-semibold uppercase tracking-wider">
              Our Expertise
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Scrap Materials We Buy
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            We purchase all types of industrial, commercial, and office scrap materials at the best market rates.
          </p>
        </div>

        {/* Materials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {materialsData.map((material, i) => {
            const Icon = iconMap[material.icon];
            return (
              <Card
                key={i}
                className="group border border-slate-100 bg-white hover:border-emerald-200 shadow-sm hover:shadow-lg hover:shadow-emerald-900/[0.06] rounded-2xl transition-all duration-300 hover:-translate-y-1 cursor-default"
              >
                <CardContent className="p-6 text-center">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-50 to-teal-50 flex items-center justify-center mx-auto mb-5 group-hover:from-emerald-100 group-hover:to-teal-100 transition-colors duration-300">
                    {Icon && (
                      <Icon className="w-7 h-7 text-emerald-700" />
                    )}
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-2">
                    {material.name}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {material.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
